<template>
  <order-list ref="orderList" :actions="actions" :default-state="2">
    <order-item ref="item" @on-update="handleUpdate"></order-item>
    <order-finance ref="orderFinance" @on-update="handleUpdate"></order-finance>
    <order-cancel ref="orderCancel" @on-update="handleActionUpdate"></order-cancel>
    <order-reject ref="orderReject" @on-update="handleActionUpdate"></order-reject>
    <order-validate ref="orderValidate" @on-update="handleActionUpdate"></order-validate>
    <order-sign ref="orderSign" @on-update="handleActionUpdate"></order-sign>
  </order-list>
</template>
<script>
import orderItem from '../base/detail'
import orderCancel from '../base/cancel'
import orderValidate from '../base/validate'
import orderReject from '../base/reject'
import orderList from '../base/list'
import orderSign from '../base/sign'
import orderFinance from '../base/finance'


export default {
  components: { orderItem  , orderCancel , orderValidate , orderReject , orderSign, orderFinance,  orderList},
  data() {
    const createAction = (h , label , fn)=>{
      return h('a', {
        props: {
          type: 'primary',
          size: 'small'
        },
        style: {
          marginRight: '5px'
        },
        on: {
          click: fn
        }
      }, label)
    }
    return {
      actions:[
        {
          title:'订单价格',
          key:'orderInfo.totalAmount',
          width:100,
        },
        // {
        //   title:'保险方案',
        //   key:'orderInsurance.name',
        //   width:120,
        // }
        // ,
        {
          title:'备注',
          key:'orderInfo.remark',
          minWidth:150,
          maxWidth:250,
          ellipsis:true,
        }
        ,
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let acts = [
              createAction(h , '查看' , ()=>{
                this.view(params)
              })
            ]

            let orderState = params.row.orderInfo.orderState
            let flowState = params.row.orderInfo.flowState
            let installment = params.row.orderInfo.isStages == 1

            //待审核
            if( orderState == 2 ){

              // 未签约成功 2 待签约 , 3 签约中, 4 签约失败 , 5 签约成功
              if( flowState < 5 && flowState >=2 ){
                acts.push(createAction(h , '签约' , ()=>{
                  this.sign(params)
                }))
              }
              
              if( installment && flowState >= 5 && flowState < 7){
                acts.push(createAction(h , '分期' , ()=>{
                  this.signForInstallment(params)
                }))
              }

              if( 
                (installment && flowState == 7) //分期 且 签约完成 可 审核
                || (!installment && flowState == 5 ) //全款 且 签约完成 可 审核
              ){
                acts.push(
                  createAction(h , '审核' , ()=>{
                    this.validate(params)
                  })
                )
              }

              acts.push(
                createAction(h , '作废' , ()=>{
                  this.cancel(params)
                }),
                createAction(h , '驳回' , ()=>{
                  this.reject(params)
                }),
              )
            }


            return h('div', acts)
          }
        }
      ]
      ,
      loading: false,
      selection:[],
      operateExplain:null
    }
  },
  computed: {
    
  },
  methods: {

    view({row}){
      this.$refs['item'].init( row.orderInfo.id )
    },
    edit(){
      // this.modalVisible = true
      // this.$refs['item'].init( row.orderInfo.id )
      // this.itemTitle = `订单编号：${row.orderInfo.orderNo}`
    },

    validate({row}){
      this.$refs['orderValidate'].init( row.orderInfo.id )
    },

    cancel({row}){
      this.$refs['orderCancel'].init( row.orderInfo.id )
    },

    sign({row}){
      this.$refs['orderSign'].init( row.orderInfo )
    },

    signForInstallment({row}){
      this.$refs['orderFinance'].init( row.orderInfo.id , `分期订单编号：${row.orderInfo.orderNo}`)
    },

    reject({row}){
      this.$refs['orderReject'].init( row.orderInfo.id )
    },

    handleUpdate(){
      this.modalVisible = false
      this.$refs['orderList'].list()
    },

    handleActionUpdate(){
      this.$refs['orderList'].list()
    },

    $update(){
      this.$refs['orderList'].list()
    }
  }
}

</script>